import PropTypes from 'prop-types'
import { idPropType } from './id-prop-type'

/**
 * Proptype that represents an entity with a unique id and name (can be anything)
 * @typedef {Object} idAndNameArrayPropType
 * @param   {idPropType} id
 * @param   {string|React.Node} name
 */
export const idAndNameArrayPropType = PropTypes.arrayOf(
    PropTypes.shape({
        affix: PropTypes.string,
        id: idPropType.isRequired,
        name: PropTypes.string.isRequired
    })
)
